export const colors: any = {
  white: '#FFFFFF',
  primary: '#5359EF',
  lightPrimary: '#ACAFFF',
  darkPrimary: '#32358F',
  secondary: '#151515',
  lightSecondary: '#1515151a',
  textSecondary: '#48484B',
  almostWhite: '#DEE2E9',
  pageBackground: '#F4F5F7',
  success: {
    main: '#10B981',
    light: '#3FC79A',
    dark: '#0B815A',
  },
  error: {
    main: '#D14343',
    light: '#DA6868',
    dark: '#922E2E',
  },
  warning: {
    main: '#FFB020',
    light: '#FFBF4C',
    dark: '#845B10', // probably not used
  },

  productsAnalytics: {
    primary: '#3A3EA8',
    secondary: '#474CCB',
    tertiary: '#5359EF',
    quaternary: '#6D72F1',
    quinary: '#868AF4',
    senary: '#A1A4F6',
    septenary: '#BABDF9',
    octonary: '#C8CBF9',
    nonary: '#D4D5FB',
    decenary: '#ECEDFD',
  },

  chip: {
    successBackground: '#D4F2E8',
    warningBackground: '#FFF1D6',
    errorBackground: '#F7DDDD',
    unknownBackground: '#E8E8E8',
  },

  bordersGray: '#E6E8F0',

  gray0: '#EEEEEE',
  gray1: '#C4B8C6',
  gray2: '#FAFAFA',
  gray3: '#000000b0',
  gray4: '#bababa',
  gray5: '#e9e9e9',
  gray6: `#757575`,
  gray7: `#d8d2da40`,
};

export const defaultChartPalette = Object.values(colors.productsAnalytics).map((color) => color as string);
